import request from "@/utils/request.js";
// 创建新的取消令牌
class Api {
  // vip等级下拉列表
  getGradeList() {
    return request({
      method: "get",
      url: "/kf_user/select/grade/list",
    });
  }
  // 客服下拉列表
  getServiceList() {
    return request({
      method: "get",
      url: "/kf_user/select/kf/list",
    });
  }
  // 会话列表
  conversationList(params) {
    return request({
      method: "get",
      url: "/conversation/list",
      params,
    });
  }
  // 关闭会话
  closeConversation(data) {
    return request({
      method: "post",
      url: "/conversation/close",
      data,
    });
  }
  // 消息未读
  unreadMessage(data) {
    return request({
      method: "post",
      url: "/conversation/unread",
      data,
    });
  }
  // 客服发消息给用户
  sendMessage(data) {
    return request({
      method: "post",
      url: "/message/kf/send_message",
      data,
    });
  }
  // 切换会话
  conversationSelect(params) {
    return request({
      method: "get",
      url: "/conversation/select",
      params,
    });
  }
  // 客服消息列表
  messageList(params) {
    return request({
      method: "get",
      url: "/message/kf/list",
      params,
    });
  }
  // 自动分配会话的开关状态
  autoAssignStatus() {
    return request({
      method: "post",
      url: "/conversation/auto_assign_status",
    });
  }
  // 修改自动分配会话的开关
  autoAssignSwitch(data) {
    return request({
      method: "post",
      url: "/conversation/auto_assign_switch",
      data,
    });
  }
  // 自动分配
  autoAssign(data) {
    return request({
      method: "post",
      url: "/conversation/auto_assign",
      data,
    });
  }
  // 指派会话
  conversationAssign(data) {
    return request({
      method: "post",
      url: "/conversation/assign",
      data,
    });
  }
  // 客服删除消息
  delMessage(data) {
    return request({
      method: "post",
      url: "/message/kf/del_message",
      data,
    });
  }
  // 编辑消息(只能修改文本消息)
  editMessage(data) {
    return request({
      method: "post",
      url: "/message/kf/edit_message",
      data,
    });
  }
  // 客服查询指定id之后未读消息列表
  unreadMessageList(params) {
    return request({
      method: "get",
      url: "/message/kf/unread/list",
      params,
    });
  }
  // 修改会话标签
  conversationChangeTag(data) {
    return request({
      method: "post",
      url: "/conversation/change_tag",
      data,
    });
  }
  // 获取单个会话信息
  conversationInfo(params) {
    return request({
      method: "get",
      url: "/conversation/info",
      params,
    });
  }
}
export default new Api();
